
import { createHelpers } from 'vuex-map-fields';

const { getMemCreateField, updateMemCreateField } = createHelpers({
	getterType: `getMemCreateField`,
	mutationType: `updateMemCreateField`,
});

const state = {
	active_menu : {},
	current_step : 'menu_show',
	excludedAddonsRedirects: [
		'land'
	],
	create_memorandum : {
		recipient : {
			user_id : "",
			rec_id : "",
		},

		form : {
			tov_id       : "",
			service_id   : "",
			question_id  : "",
			recipient_id : "",
			addon : "",
		},

		tov_list : [],
		service_list : [],
		question_list : [],
	},

	active_memorandum : {
		//form
		form: {
			tov_id : 0,
			question_id  : 0,
			service_id   : 0,
			recipient_id : 0,
			addon : ""
		},

		show_adjust : true,

		//Inside create
		organization : {},
		adjust_user : [],
		redirect_user: [],

		adjust_added       : [],
		adjust_added_after : [],
		invoice_users: [],

		adv_body : false,

		recipient : {},
		isp : {
			id : 0,
			type : "from_question",
		},

		is_dir_active : true,

		cur_user : {
			id : 0,
			email : '',
			name : "",
			username : ""
		},

		quest_data : {
			title : ''
		},

		files : [],

		preamblua : '',
		problem : '',
		result : '',
		title : '',

		reason_number : '',
		addon_data : [],
	},
}

const getters = {
	getMemCreateField,

	getCreateMem() {
		return state.create_memorandum;
	}
}

const actions = {

	SET_ACTIVE_MENU({commit}, data) {
		commit('set_active_menu', data)
	},

	SET_CURRENT_STEP({commit}, step) {
		commit('set_current_step', step)
	},

	DELETE_ACTIVE_MENU ({commit}) {
		commit('del_active_menu')
	},

	SET_ACTIVE_MEMORANDUM ({commit}, data) {
		commit('set_active_memorandum', data)
	},

	SET_CREATE_MEM_FIELDS ({commit}, data) {
		commit('set_cr_mem_fields', data)
	},

	SET_ACTIVE_MEMORANDUM_FILES ({commit}, data) {
		commit('set_active_memorandum_files', data)
	},

	SET_ACTIVE_MEMORANDUM_ADJUST ({commit}, data) {
		commit('set_active_memorandum_adjust', data)
	},

	DEL_ACTIVE_MEMORANDUM_ADJUST({commit}) {
		commit('del_active_memorandum_adjust')
	},

	SET_ACTIVE_MEMORANDUM_ADJUST_AFTER ({commit}, data) {
		commit('set_active_memorandum_adjust_after', data)
	},

	DEL_ACTIVE_MEMORANDUM_ADJUST_AFTER({commit}) {
		commit('del_active_memorandum_adjust_after')
	},

	UPDATE_ACTIVE_MEM( {commit}, data) {
		commit('update_active_mem', data)
	},
}

// mutations
const mutations = {
	updateMemCreateField,
	set_cr_mem_fields(state, data) {
		state.create_memorandum = {...state.create_memorandum, ...data}
	},


	set_current_step (state,step) {
		state.current_step = step;
	},

	set_active_menu (state, data) {
		state.active_menu = {...state.active_menu, ...data}

		if(data.addon != undefined) {
			state.create_memorandum.form.addon = data.addon;
		}

		state.current_step = 'menu_active';
	},

	del_active_menu (state) {
		state.active_menu = {};
		state.create_memorandum.form.addon = '';
		state.current_step = 'menu_show';
	},

	set_active_memorandum(state,data) {
		state.current_step = 'mem_preview';
		state.active_memorandum = {...state.active_memorandum, ...data}


		if(data.hasOwnProperty("adjust_user")) {
			let adjust_users = data.adjust_user;
			let dir_id = parseInt(data.organization.director_id);

			if(adjust_users.length > 0) {
				let DirInAjust = adjust_users.find(user => parseInt(user.id) === dir_id);
				state.active_memorandum.is_dir_active = (DirInAjust == undefined);
			}

			// replace adjust_user on redirect_user
			if(!state.excludedAddonsRedirects.includes(state.active_memorandum?.cur_addon)){
				replaceAdjustUsers(state.active_memorandum);
			}
		}

		if(data.hasOwnProperty("placeholder")) {
			state.active_memorandum.preamblua = data.placeholder?.pre_text || '';
			state.active_memorandum.problem = data.placeholder?.problem || '';
			state.active_memorandum.result = data.placeholder?.result || '';
		}


		EventBus.$emit("set_memorandum_data",state.active_memorandum);
	},

	set_active_memorandum_files(state,data) {
		state.active_memorandum.files = data;
	},

	update_active_mem (state,data) {
		state.active_memorandum = {...state.active_memorandum, ...data}
	},

	set_active_memorandum_adjust(state, data) {
		state.active_memorandum.adjust_added = data;
	},

	set_active_memorandum_adjust_after(state, data) {
		state.active_memorandum.adjust_added_after = data;
	},

	del_active_memorandum_adjust_after() {
		state.active_memorandum.adjust_added_after = [];
	},

	del_active_memorandum_adjust() {
		state.active_memorandum.adjust_added = [];
	},
}

function replaceAdjustUsers(activeMemorandum) {
	const redirect_user = activeMemorandum?.redirect_user ?? [];
	redirect_user.forEach(item => item.user_redirect.user_name_redirect = item?.user?.name);
	const adjust_user = JSON.parse(JSON.stringify(activeMemorandum?.adjust_user ?? []));
	const mem_adjust_user = activeMemorandum?.adjust_user ?? [];
	mem_adjust_user.length = 0;

	adjust_user.forEach(adjust => {
		const redirectRecord = redirect_user.find(redirect => {
			return redirect?.user?.id === adjust?.id
		});

		if (redirectRecord) {
			const findIndex = mem_adjust_user.findIndex(findUser =>
				findUser.id === redirectRecord?.user_redirect?.id);
			if(findIndex < 0) {
				mem_adjust_user.push(redirectRecord?.user_redirect);
			}
		} else {
			const findIndex = mem_adjust_user.findIndex(findUser =>
				findUser.id === adjust?.id);
			if(findIndex < 0) {
				mem_adjust_user.push(adjust);
			}
		}
	})
}
export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
}


